/**
 * MeridianLogo — compass rose icon + MERIDIAN wordmark
 * variant="light"  → dark teal elements on Pearl/light background (default)
 * variant="dark"   → Pearl elements on dark/teal background
 */
export default function MeridianLogo({ variant = 'light' }) {
  const iconColor  = variant === 'dark' ? '#F0EEE9' : '#0D3D4A';
  const textColor  = variant === 'dark' ? '#F0EEE9' : '#0D3D4A';
  const strokeColor = iconColor;

  // Rotate helper
  const pts = [0, 90, 180, 270];
  const inter = [45, 135, 225, 315];

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
      {/* Compass Rose SVG — 32×32 */}
      <svg
        width="32"
        height="32"
        viewBox="0 0 500 500"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        {/* Cardinal points (4 long arms) */}
        {pts.map(deg => (
          <path
            key={`card-${deg}`}
            d="M 250,44 C 251,88 257,140 258,158 L 263,171 L 257,177 L 250,179 L 243,177 L 237,171 L 242,158 C 243,140 249,88 250,44 Z"
            fill={iconColor}
            transform={`rotate(${deg} 250 250)`}
          />
        ))}

        {/* Intercardinal points (4 short arms) */}
        {inter.map(deg => (
          <path
            key={`inter-${deg}`}
            d="M 250,107 C 251,128 254,148 255,159 L 258,168 L 254,173 L 250,175 L 246,173 L 242,168 L 245,159 C 246,148 249,128 250,107 Z"
            fill={iconColor}
            transform={`rotate(${deg} 250 250)`}
          />
        ))}

        {/* Annulus ring */}
        <path
          fillRule="evenodd"
          d="M 250,174 A 76,76 0 0,1 250,326 A 76,76 0 0,1 250,174 Z M 250,190 A 60,60 0 0,1 250,310 A 60,60 0 0,1 250,190 Z"
          fill={iconColor}
        />

        {/* M letterform */}
        <path
          d="M 226,272 L 226,228 L 250,248 L 274,228 L 274,272"
          fill="none"
          stroke={strokeColor}
          strokeWidth="8.5"
          strokeLinecap="square"
          strokeLinejoin="miter"
          strokeMiterlimit="10"
        />
      </svg>

      {/* Wordmark */}
      <span
        style={{
          fontFamily: "'Playfair Display', Georgia, serif",
          fontWeight: 400,
          fontSize: 18,
          letterSpacing: '0.15em',
          color: textColor,
          lineHeight: 1,
          userSelect: 'none',
        }}
      >
        MERIDIAN
      </span>
    </div>
  );
}
